import { LOCAL_STORAGE_KEYS } from "../../../constants/local-storage-keys";
import { GenerateJWTToken } from "../../../services/modules/jwt";
import {
  CheckCustomer,
  GetCustomerDetail,
} from "../../../services/modules/verify";

export async function refreshToken({ idCard, idPassport, isForeigner }) {
  const { token } = await GenerateJWTToken(isForeigner ? idPassport : idCard);

  localStorage.setItem(LOCAL_STORAGE_KEYS.AUTH_TOKEN, token);
}

export async function signIn({ idCard, idPassport, dateOfBirth, isForeigner }) {
  try {
    const { token } = await GenerateJWTToken(isForeigner ? idPassport : idCard);

    localStorage.setItem(LOCAL_STORAGE_KEYS.AUTH_TOKEN, token);

    const customerDetail = {
      id_card: isForeigner ? String(idPassport) : String(idCard),
      date_of_birth: dateOfBirth,
    };

    const response = await GetCustomerDetail({ body: customerDetail });

    const isResponseSuccess = response.resultCode === "20000";

    if (isResponseSuccess) {
      const { token } = response;

      localStorage.setItem(
        LOCAL_STORAGE_KEYS.ID_CARD,
        isForeigner ? String(idPassport) : String(idCard)
      );

      localStorage.setItem(LOCAL_STORAGE_KEYS.DATE_OF_BIRTH, dateOfBirth);

      sessionStorage.setItem("authToken", token);
    }

    return { response };
  } catch (error) {
    console.error("[ERROR] : ล้มเหลวในการเข้าสู่ระบบ");
  }
}

export async function checkUserExistence(idCard) {
  const response = await CheckCustomer({ body: { id_card: idCard } });

  if (!response.resultData) return false;

  return response.resultData[0];
}
